<script lang="ts">
    import { DatePicker, DatePickerInput } from "carbon-components-svelte";
    import * as xlsx from "xlsx";
    import dayjs, { Dayjs } from "dayjs";
    import weekday from "dayjs/plugin/weekday";
    import de from "dayjs/locale/de";
    import type { rangeObject } from "../../../../../Types/Stats";
    import type { IXlsxExportObject } from "../../../../../Types/Xlsx";

    dayjs.extend(weekday).locale(de);

    export let changeDateCallback = (range: rangeObject): void => {
        return;
    };
    export let changeSearchCallback = (e: any): void => {
        return;
    };
    export let searchDisabled = false;

    export let changeDateActivated = true;

    export let exportActivated = false;
    export let exportFileName = "export_";
    export let exportObject: IXlsxExportObject<any> = {
        header: {},
        data: [{}],
    };

    const exportXlsx = async (object: IXlsxExportObject<any>) => {
        const worksheet = xlsx.utils.json_to_sheet(
            [exportObject.header].concat(exportObject.data),
            { skipHeader: true }
        );

        const workbook = xlsx.utils.book_new();
        xlsx.utils.book_append_sheet(workbook, worksheet, "");

        /* generate an XLSX file */
        xlsx.writeFile(
            workbook,
            exportFileName +
                range.start.format("hh:mm_DD-MM-YYYY") +
                "_" +
                range.end.format("hh:mm_DD-MM-YYYY") +
                ".xlsx"
        );
        return;
    };

    const ranges: rangeObject[] = [
        {
            text: "Heute",
            start: dayjs()
                .set("ms", 0)
                .set("s", 0)
                .set("minute", 0)
                .set("hour", 0),
            // .set("hour", 0),
            end: dayjs(),
        },
        {
            text: "Aktuelle Woche",
            start: dayjs()
                .set("ms", 0)
                .set("s", 0)
                .set("minute", 0)
                .set("hour", 0)
                .weekday(0),
            end: dayjs(),
        },
        {
            text: "Aktueller Monat",
            start: dayjs()
                .set("ms", 0)
                .set("s", 0)
                .set("minute", 0)
                .set("hour", 0)
                .date(1),
            end: dayjs(),
        },
    ];

    let timeDropdownActive = false;
    let exportDropdownActive = false;
    let range = ranges[1];
    let defaultPeriodLengthInSec = 3600;
</script>

<div class="columns">
    <div class="column is-6">
        <div class="columns float-left">
            {#if changeDateActivated}
                <div class="column is-4">
                    <div
                        class="dropdown is-left {timeDropdownActive &&
                            'is-active'}"
                    >
                        <div
                            class="dropdown-trigger"
                            on:click={() =>
                                (timeDropdownActive = !timeDropdownActive)}
                        >
                            <button
                                class="button gradient-left"
                                aria-haspopup="true"
                                aria-controls="dropdown-menu"
                            >
                                <span>{range.text}</span>
                                {#if timeDropdownActive}
                                    <span class="icon is-small">
                                        <i
                                            class="fas fa-angle-up"
                                            aria-hidden="true"
                                        />
                                    </span>
                                {:else}
                                    <span class="icon is-small">
                                        <i
                                            class="fas fa-angle-down"
                                            aria-hidden="true"
                                        />
                                    </span>
                                {/if}
                            </button>
                        </div>
                        <div
                            class="dropdown-menu"
                            id="dropdown-menu"
                            role="menu"
                        >
                            <div class="dropdown-content">
                                {#each ranges as rangeObject}
                                    <!-- svelte-ignore a11y-invalid-attribute -->
                                    <a
                                        href="#"
                                        class="dropdown-item"
                                        on:click={() => {
                                            range = rangeObject;
                                            timeDropdownActive = false;
                                            changeDateCallback(rangeObject);
                                        }}
                                    >
                                        {rangeObject.text}
                                    </a>
                                {/each}
                                <!-- <hr class="dropdown-divider" />
                                <DatePicker datePickerType="range" on:change>
                                    <DatePickerInput
                                        labelText="Start date"
                                        placeholder="mm/dd/yyyy"
                                    />
                                    <DatePickerInput
                                        labelText="End date"
                                        placeholder="mm/dd/yyyy"
                                    />
                                </DatePicker> -->
                            </div>
                        </div>
                    </div>
                </div>
            {/if}
            {#if !searchDisabled}
                <div class="column is-6">
                    <div class="field is-grouped">
                        <p class="control is-expanded">
                            <input
                                class="input"
                                type="text"
                                placeholder="Suche"
                                on:change={(e) => {
                                    changeSearchCallback(e);
                                }}
                            />
                        </p>
                    </div>
                </div>
            {/if}
            {#if exportActivated}
                <div class="column is-2">
                    <div
                        class="field dropdown is-left {exportDropdownActive &&
                            'is-active'}"
                    >
                        <div
                            class="dropdown-trigger"
                            on:click={() =>
                                (exportDropdownActive = !exportDropdownActive)}
                        >
                            <button
                                class="button gradient-left"
                                aria-haspopup="true"
                                aria-controls="dropdown-menu"
                            >
                                <span>Export</span>
                                {#if exportDropdownActive}
                                    <span class="icon is-small">
                                        <i
                                            class="fas fa-angle-up"
                                            aria-hidden="true"
                                        />
                                    </span>
                                {:else}
                                    <span class="icon is-small">
                                        <i
                                            class="fas fa-angle-down"
                                            aria-hidden="true"
                                        />
                                    </span>
                                {/if}
                            </button>
                        </div>
                        <div
                            class="dropdown-menu"
                            id="dropdown-menu"
                            role="menu"
                        >
                            <div class="dropdown-content">
                                <!-- svelte-ignore a11y-invalid-attribute -->
                                <a
                                    href="#"
                                    class="dropdown-item"
                                    on:click={() => {
                                        exportDropdownActive = false;
                                        exportXlsx(exportObject);
                                    }}
                                >
                                    <span class="icon is-small">
                                        <i
                                            class="fas fa-file-excel"
                                            aria-hidden="true"
                                        />
                                    </span>
                                    Excel
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            {/if}
        </div>
    </div>
</div>

<style>
    .input {
        height: 40px;
    }
    .field {
        margin-left: 20px;
    }

    .float-left {
        float: left;
    }

    .columns {
        position: sticky;
        top: 0;
        z-index: 100;
        background-color: #f4f4f4;
    }
</style>
